// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_E13p8){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3mFUu .dualColumn_KCjC3{display:flex;align-content:space-between}.nsAddressForm_3mFUu .dualColumn_KCjC3 .firstCol_2iA6W{margin-right:20px}.optional_1cUUh{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_E13p8",
	"nsAddressForm": "nsAddressForm_3mFUu",
	"dualColumn": "dualColumn_KCjC3",
	"firstCol": "firstCol_2iA6W",
	"optional": "optional_1cUUh"
};
module.exports = exports;
